export class StudentCourseRequest {
}

export class StudentCourseRequestDetailDTO {
    RowNumber: number;
    DistrictRequirement_ID: number;
    SchoolRequirement_ID: number;
    GradeLevel_ID: number;
    RequirementName: string;
    RequirementInstructions: string;
    RequirementType: number;
    ReqMinCredits: number;
    ReqMaxCredits: number;
    ReqMinCourses?: number;
    ReqMaxCourses?: number;
    DefaultNumberOfCourseRequests: number;
    AllowGlobalAlternates: boolean;
    AltMinCredits: number;
    AltMaxCredits: number;
    AltMinCourses?: number;
    AltMaxCourses?: number;
    AllowIndividualAlternates: boolean;
    NumberOfIndividualAlternates: number;
    RequestedCredits: number;
    StudentCourseRequest_ID: number;
    DistrictCourse_ID: number;
    CRType: string;
    ParentCR_ID: number;
    PreferredTeacher?: number;
    PreferredTerm: string;
    PreferredPeriod: string;
    Conflicts: number;

    // Non-DTO Fields
    isHiddenRow: boolean;
    isHover: boolean;
    HighlightMinCredit: boolean;
    HighlightMaxCredit: boolean;
    HighlightMinCourses: boolean;
    HighlightMaxCourses: boolean;
    RequestedCourses: number;
    imageUrl: string;
    PreferredTeacherNameSetByCounselor: string;
    Status: string;
}
export class GradeLevelRequirements {
    DistrictRequirement_ID: number;
    SchoolRequirement_ID: number;
    GradeLevel_ID: number;
    RequirementName: string;
    RequirementInstructions: string;
    RequirementType: number;
    ReqMinCredits: number;
    ReqMaxCredits: number;
    ReqMinCourses?: number;
    ReqMaxCourses?: number;
    DefaultNumberOfCourseRequests: number;
    AllowGlobalAlternates: boolean;
    AltMinCredits: number;
    AltMaxCredits: number;
    AltMinCourses: number;
    AltMaxCourses: number;
    AllowIndividualAlternates: boolean;
    NumberOfIndividualAlternates: number;
    RequestedCredits: number;
    StudentCourseRequest: StudentCourseRequestDTO[];

    HighlightMinCredit: boolean;
    HighlightMaxCredit: boolean;
    HighlightMinCourses: boolean;
    HighlightMaxCourses: boolean;
    RequestedCourses?: number;
}

export class StudentCourseRequestDTO {
    DistrictRequirement_ID: number;
    StudentCourseRequest_ID: number;
    DistrictCourse_ID: number;
    Status: string;
    CRType: string;
    ParentCR_ID: number;
    PreferredTeacher: number;
    PreferredTerm: string;
    PreferredPeriod: string;
    Conflicts: number;
    isHiddenRow: boolean;
    PreferredTeacherNameSetByCounselor: string;
}

export class CreditIndicators {
    DistrictRequirement_ID: number;
    ReqMinCredits: number;
    ReqMaxCredits: number;
    ReqMinCourses?: number;
    ReqMaxCourses?: number;
    RequestedCredits: number;
    RequestedCourses?: number;
    HighlightMinCredit: boolean;
    HighlightMaxCredit: boolean;
    HighlightMinCourses: boolean;
    HighlightMaxCourses: boolean;
}
export class OverallRequirement {
    ReqMinCredits: number;
    ReqMaxCredits: number;
    ReqMinCourses?: number;
    ReqMaxCourses?: number;
    RequestedCredits: number;
    RequestedCourses?: number;
    HighlightOverallMinCredit: boolean;
    HighlightOverallMaxCredit: boolean;
    HighlightOverallMinCourses: boolean;
    HighlightOverallMaxCourses: boolean;
}

export class CourseRequestSchoolPolicyDTO {
    ID: number;
    SiteYear_ID: number;
    CR360PreventParentStudentSubmittingCourseRequests: boolean;
    CR360AllowParentStudentRequestWhenPrerequisiteNotMeet: boolean;
    CR360AllowParentStudentRequestOutsideOfStudentGradeLevel: boolean;
    CR360EnforceRule: string;
}

export class SchoolPoliciesCR360ParentStudentViewDTO {
    ID: number;
    SiteYear_ID: number;
    ColumnToCheck: string;
    CanDisplay: boolean;
    CanEdit: boolean;
}

export class CRRequirementCourses {

    // Server Properties
    CourseId: number;
    DistrictRequirement_ID: number;
    ValueField: number;
    TextField: string;
    Credits: number;
    GradeLevels: string;
    IsPrerequisiteMissing: boolean;
    IsAlreadyRequestedCR: boolean;
    IsCourseAlreadyTaken: boolean;
    CourseName: string;
    CourseCurriculum: string;
    CourseDescription: string;
    SubjectIdentifier: string;
    SubjectTermType: string;
    CreditDeliveryTermType: string;
    SemestersPerYear: number;
    TermsPerSemesters: number;

    // Local Properties
    courseCredits: string;
    courseName: string;
    courseNumber: string;
}

export class CRLookupDTO {
    CourseId: number;
    DistrictRequirement_ID: number;
    ValueField: number;
    TextField: string;
}

export class Courses {
    RequirementId: number;
    CourseId: number;
    CourseName: string;
}

export class CourseDescription {
    CourseName: string;
    CourseCurriculum: string;
    CourseDescription: string;
    SubjectIdentifier: string;
    // not in DTO
    CourseNumber: string;
}

export class StudentCourseRequestPreferredTeachers {
    StudentCourseRequest_ID: number;
    PreferredTeacherStaff_ID?: number;
    PreferredTeacherName: string;
}
